import { Inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment.development';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class InitialService {
  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    private titleService: Title
  ) {}

  script = document.createElement('script');
  async setUpGoogleScript(): Promise<void> {
    setTimeout(() => {
      // Set Google Api keY DYNAMICALLY
      const head = document.getElementsByTagName('body')[0];

      if (!document.getElementById('testScriptName')) {
        this.script.type = 'text/javascript';
        this.script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleKey}&libraries=places,drawing,geometry,visualization&language=en`;
        this.script.id = 'newTestScriptName';
        this.script.async = true;
        head.appendChild(this.script);
      }
    }, 100);
  }

  api: any;
  projectSettings:any;
  // projectSettings = {
  //   colorCodes: '#ff0000',
  //   secondaryColor:'#ff0000',
  //   favIcon: 'https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png',
  //   appName: 'Goluuuu',
  //   buttonPrimary: '#008CBA',
  //   buttonTextColor: '#ffffff',
  //   appLogo: 'https://example.com/app-logo.png',
  //   webLogo: 'https://example.com/web-logo.png'
  // };

  async load(): Promise<void> {
    this.setData();
    this.api = `${environment.base_url}settings`;
    await this.getGreatSettings();
  }

  async getGreatSettings(): Promise<void> {
    const res = await this.http.get<any>(this.api).toPromise();
    if (res?.data) {
      this.projectSettings = res.data;
      this.setData();
    }
  }

  setData(): void {
    localStorage.setItem('webSettings', JSON.stringify(this.projectSettings));
    if (this.projectSettings && this.projectSettings.colorCodes) {
      document.documentElement.style.setProperty(
        '--primary-color',
        this.projectSettings.colorCodes
      );
    }

    if (this.projectSettings?.secondaryColor) {
      document.documentElement.style.setProperty('--secondary-color', this.projectSettings.buttonPrimary);
    }

    // Set button primary color and button text color
    if (this.projectSettings?.buttonPrimary) {
      document.documentElement.style.setProperty('--button-primary-color', this.projectSettings.buttonPrimary);
    }
    if (this.projectSettings?.buttonTextColor) {
      document.documentElement.style.setProperty('--button-text-color', this.projectSettings.buttonTextColor);
    }

    // Set Favicon
    if (this.projectSettings?.favIcon) {
      const faviconElement = this._document.getElementById('appFavicon');
      if (faviconElement) {
        faviconElement.setAttribute('href', this.projectSettings.favIcon);
      }
    }

    // Set Title
    if (this.projectSettings && this.projectSettings.appName) {
      this.titleService.setTitle(`${this.projectSettings.appName}`);
    }

    // Set app logo and web logo
    if (this.projectSettings?.appLogo) {
      const appLogoElement = this._document.getElementById('appLogo');
      if (appLogoElement) {
        appLogoElement.setAttribute('src', this.projectSettings.appLogo);
      }
    }

    if (this.projectSettings?.webLogo) {
      const webLogoElement = this._document.getElementById('webLogo');
      if (webLogoElement) {
        webLogoElement.setAttribute('src', this.projectSettings.webLogo);
      }
    }
  }
}
